<div [ngClass]="className">
  <textarea
    [maxlength]="maxCharCount"
    matInput
    placeholder="{{ placeHolderText }}"
    [formControl]="control"
    class="autosize-input paragraph-medium-regular"
    [ngClass]="{ 'read-only-text': isReadOnly }"
    [readonly]="isReadOnly"
  ></textarea>
  <p class="word-counter paragraph-small-regular">{{ wordCount }}/{{ maxCharCount }}</p>
</div>
